// extracted by mini-css-extract-plugin
export default {"mCard":"_s-z","image":"at-z","imageNoBackground":"bt-z","fullWidth":"ct-z"};